
//import { CoordinateProcessor } from '../../utils/CoordinateProcessor';
import { useMapStore } from "../../store/useMapStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import { BBOxRelativeToCenter, mercatorRelative } from "../../services/MercatorRelativeToCenter.js";


export class RiskAreaEntity {
    
    constructor(data = {}) {

        
        this.objectId = data.objectId || "n.z.";
        this.waterType = data.waterType || "";
        this.waterName = data.waterName || '';
        this.exteriorring = data.exteriorRing.coordinates || "";
        this.interiorring = data.interiorRings.coordinates || "";
        this.id = data.id || '';
        this.Name = "RiskAreaEntity";
    }

    // Static method to create multiple entities from raw response
    static fromResponse(response) 
    {
        
        // Check if the response structure matches your expected format
        if (response)
        {
           
            return response.data.riskAreaByBounds.riskAreas.map(
                entityData => new RiskAreaEntity(entityData)
            );
        }
        return [];
    }
      
}